import { render, staticRenderFns } from "./ManualPurchase.vue?vue&type=template&id=f8763544"
import script from "./ManualPurchase.vue?vue&type=script&lang=js"
export * from "./ManualPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports